var exports = {
  "M": "xae11d333--235d9a--slide",
};

module.exports = exports;
